module.exports = __webpack_public_path__ + "static/img/vrroad_card.5eae0aae.png";